import React from 'react';

import { StyledLabel } from './label.style';

const Label = (props) => {
  const {
    loading = false,
    size = 'normal',
    weight = 'normal',
    color = 'normal',
    children,
    cursor = 'default',
    varient = 'normal',
    display = 'inline-block',
    align = 'left',
    maxWidth,
    transform = 'initial',
    disabled = false,
    lineHeight,
    isElips = false,
    ...otherProps
  } = props;

  return (
    <StyledLabel
      size={size}
      weight={weight}
      color={color}
      cursor={cursor}
      varient={varient}
      display={display}
      align={align}
      maxWidth={maxWidth}
      transform={transform}
      disabled={disabled}
      lineHeight={lineHeight}
      isElips={isElips}
      {...otherProps}
    >
      {loading && '...'}
      {!loading && children}
    </StyledLabel>
  );
};

export default Label;
